import type { RouteRecordRaw } from "vue-router";

export const bookmarksRoutes: RouteRecordRaw[] = [
  {
    path: "/bookmarks",
    name: "bookmark-index",
    component: () => import("./BookmarkListPage.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
